































import { Component, Mixins, Prop } from "vue-property-decorator";
import { Document, DocumentAttributes, DocumentButtonControl } from "../../../../domain/document";
import { IContentSource } from "../../../../domain/drawing";
import { DomainRegistry } from "../../../../domain";
import { DialogMixin, PdfStyleDrawableMixin } from "../../../system/mixins";
import PdfViewer from "../../../system/viewers/PdfViewer.vue";
import { CommonComponentsAccessibleMixin } from "../mixins";
import { IDocumentEditMenuConfiguration, IDocumentEditMenuButtonsConfiguration, IDocumentEditMenuButtonConfiguration } from "../../../document/editor/contents";

@Component({
  components: {
    PdfViewer
  }
})
export default class PrintPdfPreviewDialog extends Mixins(DialogMixin, CommonComponentsAccessibleMixin, PdfStyleDrawableMixin) {
  @Prop()
  createPreviewCacheSource: (document: Document) => Promise<IContentSource>;

  @Prop()
  editMenuConfiguration: IDocumentEditMenuConfiguration;

  document: Document;
  src: string;
  page: number;
  isPrintable: boolean;
  
  data(): any {
    return {
      document: null,
      src: null as string,
      page: 1,
      isPrintable: false,
    };
  }

  get isLoading(): boolean {
    return (this.src === null);
  }

  get shouldPrintWatermarkForcibly(): boolean {
    return this.$configuration.behavior.document.editor.preview.shouldPrintWatermarkForcibly;
  }

  getButtonName(accessor: (c: IDocumentEditMenuButtonsConfiguration) => IDocumentEditMenuButtonConfiguration, name: string): string {
    const buttonConfiguration = (this.editMenuConfiguration && this.editMenuConfiguration.buttons)
      ? accessor(this.editMenuConfiguration.buttons)
      : null;
    return (buttonConfiguration && buttonConfiguration.name)
    ? buttonConfiguration.name
    : name;
  }

  get attributes(): DocumentAttributes {
    return this.document
      ? this.document.attributes
      : null;
  }

  get buttonControl(): DocumentButtonControl {
    return (this.attributes && this.attributes.behavior && this.attributes.behavior.enableButtonControl && this.attributes.buttonControl)
      ? this.attributes.buttonControl
      : null;
  }

  get isPrintButtonVisible(): boolean {
    return (!this.buttonControl || this.buttonControl.isPrintEnable === null || this.buttonControl.isPrintEnable) && this.isDocumentPrintable;
  }

  get isPrintWithDialogButtonVisible(): boolean {
    return (!this.buttonControl || this.buttonControl.isPrintWithDialogEnable === null || this.buttonControl.isPrintWithDialogEnable) && this.isDocumentPrintable;
  }

  get isDocumentPrintable(): boolean {
    return this.$store.getters.userAuthority.documentPrintable;
  }

  private async createPreviewSource(document: Document, shouldShowPrintPreview: boolean): Promise<IContentSource> {
    return this.createPreviewCacheSource
    ? this.createPreviewCacheSource(document)
    : this.createDocumentPreviewSource(document, shouldShowPrintPreview);
  }

  private async createDocumentPreviewSource(document: Document, shouldShowPrintPreview: boolean): Promise<IContentSource> {
    return shouldShowPrintPreview
      ? DomainRegistry.document.getDocumentRepository().createPrintPreviewSource(document)
      : DomainRegistry.document.getDocumentRepository().createPreviewSource(document);
  }

  async show(document: Document, page: number, isPrintable: boolean, shouldShowPrintPreview: boolean = false): Promise<void> {
    return this._show(
      d => {
        return this.createPreviewSource(document, shouldShowPrintPreview);
      },
      document,
      page,
      isPrintable);
  }

  private async _show(create: (d: Document) => Promise<IContentSource>, document: Document, page: number, isPrintable: boolean): Promise<void> {
    return this.showModal(async () => {
      this.document = document;
      this.src = null;
      this.page = page;
      this.isPrintable = isPrintable;

      create(document)
      .then(source => {
        if (!source) {
          this.$error("印刷PDF取得エラー", "印刷PDFを取得できませんでした。");
          return;
        }
        this.src = source.source;
      })
      .catch(e => {
        this.$error(
          "印刷PDF取得エラー",
          "印刷PDFを取得できませんでした。",
          e
        );
      });
      await this.waitHidden();
    });
  }

  async showForDebug(create: (d: Document) => Promise<IContentSource>, document: Document, page: number): Promise<void> {
    return this._show(
      create,
      document,
      page,
      true);
  }

  public print(shouldSelectPrinter: boolean = false): void {
    // 確認のために印刷したい用途なら複数の部数が出ないほうが良いと思われるため、defaultCopiesを使用せず1部のみ印刷する
    this.commonComponents.operators.printer.print(shouldSelectPrinter, false, this.shouldPrintWatermarkForcibly);
  }
}
